import React, { useEffect } from 'react';
import classes from './WarningBar.module.css';

const WarningBar = ({ text, color = '#F03C3C', durationMs = 10000, onDismiss }) => {

  useEffect(() => {
    const timer = setTimeout(() => {
      onDismiss?.();
    }, durationMs);
    return () => clearTimeout(timer);
  }, [durationMs, onDismiss]);

  return (
    <div className={classes.warningBar} style={{ backgroundColor: color }} role="alert">
      <span className={classes.text}>{text}</span>
    </div>
  );
};

export default WarningBar;
